import React, { useEffect, useState } from 'react'
import styles from './style.module.css';
import moment from 'moment';
import { v3_candidate_history } from '../../../../actions/v3/candidates';
const Detail = ({ label, value }) => {
    return (
        <div className={`${styles.detail} ${styles.detailBox}`}>
            <span className={styles.labeleHead}>{label}:</span> <span className={styles.valueLable}>{value}</span>
        </div>
    );
};
const Header = ({ label }) => {
    return (
        <div className={`${styles.detail} ${styles.detailBox}`}>
            <span className={styles.labeleHead}>{label}</span>
        </div>
    );
};

const History = (props) => {
    const { data } = props;
    const [history, setHistory] = useState([])
    useEffect(() => {
        v3_candidate_history(data.CANDIDATE_ID).then((res) => {
            setHistory(res.result)
        })
    }, [])
    return (
        <React.Fragment>
            <div className={styles.profilViewModalSection}>
                <div className="popupCandidateFormStyle">
                    <div className={styles.modalCandidateBox}>
                        <div className={styles.whatppBox}>
                            <Header className={styles.labelNotify} label={data.FULL_NAME + ' History'} />
                        </div>
                    </div>
                    <div className={`${styles.detailscontainer} ${styles.detailscontainerBox}`}>
                        <Detail label="Created On" value={moment(data.CREATED_ON).format('DD-MM-YYYY')} />
                        {history.map(item => {
                            return (
                                <Detail
                                    label={item.STATUS_NAME}
                                    value={`${item.JOB_TITLE ? `For ${item.JOB_TITLE}` : ''} 
          ${item.LINED_UP_DATE ? ` at ${moment(item.LINED_UP_DATE).format('DD-MMM-YYYY')} ${item.LINED_UP_TIME || ''}` : ''} 
          on ${moment(item.CREATED_ON).format('DD-MMM-YYYY')}
          ${item.CREATED_BY_NAME ? 'by ' + item.CREATED_BY_NAME : ''}
          `}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default History